var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1992 7.94688C19.1992 8.69246 18.5948 9.29688 17.8492 9.29688C17.1036 9.29688 16.4992 8.69246 16.4992 7.94688C16.4992 7.20129 17.1036 6.59688 17.8492 6.59688C18.5948 6.59688 19.1992 7.20129 19.1992 7.94688ZM20.9992 7.94688C20.9992 9.68657 19.5889 11.0969 17.8492 11.0969C16.575 11.0969 15.4776 10.3404 14.9815 9.25198C14.8929 9.28111 14.7983 9.29688 14.7 9.29688H3.9C3.40294 9.29688 3 8.89393 3 8.39687C3 7.89982 3.40294 7.49688 3.9 7.49688H14.7C14.7104 7.49688 14.7207 7.49706 14.731 7.4974C14.9492 5.97061 16.2621 4.79688 17.8492 4.79688C19.5889 4.79688 20.9992 6.20718 20.9992 7.94688ZM7.5 16.0465C7.5 16.7921 6.89558 17.3965 6.15 17.3965C5.40442 17.3965 4.8 16.7921 4.8 16.0465C4.8 15.3009 5.40442 14.6965 6.15 14.6965C6.89558 14.6965 7.5 15.3009 7.5 16.0465ZM6.15 19.1965C7.42424 19.1965 8.52176 18.4399 9.01783 17.3514C9.1067 17.3808 9.20169 17.3967 9.30039 17.3967H20.1004C20.5974 17.3967 21.0004 16.9937 21.0004 16.4967C21.0004 15.9996 20.5974 15.5967 20.1004 15.5967H9.30039C9.28962 15.5967 9.27889 15.5969 9.26821 15.5972C9.05018 14.0703 7.73718 12.8965 6.15 12.8965C4.4103 12.8965 3 14.3068 3 16.0465C3 17.7862 4.4103 19.1965 6.15 19.1965Z",
    fill: "#FF4A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.ff5dc2623ef06412afd2a77abb2842e9.svg";
export { ForwardRef as ReactComponent };